import { useRouter } from "next/router";
import { useCallback, useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { AuthContext } from "../context/AuthContext";
import { AuthModalContext } from "../context/AuthModalContext";
import { deleteData } from "../utils/deleteData";
import { postData } from "../utils/postData";
import { useLikedCases } from "./handleLikes";

const useLike = (count: number, url: string, likeByAuth: boolean) => {
  const { handleLike, handleUnlike, likedCases } = useLikedCases();
  const isLiked = likedCases.includes(url);

  const [likeBtnClicked, setLikeBtnClicked] = useState(false);
  const [like, setLike] = useState(count || 0);
  const { asPath } = useRouter();

  const { donor } = useContext(AuthContext);
  const { handleShowAuthModal } = useContext(AuthModalContext);

  useEffect(() => {
    setLike(count);
    if (likeByAuth) {
      setLikeBtnClicked(true);
    } else if (isLiked) {
      setLikeBtnClicked(true);
      setLike((prev) => (prev = prev + 1));
    } else {
      setLikeBtnClicked(false);
    }
  }, [asPath, likeByAuth, isLiked]);

  // on Like button click function

  /**
   * It makes a POST request to the server to like a post.
   * @param e - The event object.
   */
  const onLikeBtnClick = useCallback(
    async (e) => {
      // checking if it was clicked or not
      if (!donor) {
        handleShowAuthModal();
        return;
      }
      if (!likeBtnClicked) {
        try {
          setLikeBtnClicked(true);

          setLike((prevLike) => (prevLike = prevLike + 1));
          handleLike(url);
          const res = await postData(`${url}`);
        } catch (error) {
          toast.error(error?.response?.data?.error?.code);
          setLike((prevLike) => (prevLike = prevLike - 1));
          setLikeBtnClicked(false);
        }
      } else {
        setLike((prevLike) => (prevLike = prevLike - 1));
        setLikeBtnClicked(false);

        handleUnlike(url);
        try {
          const res = await deleteData(`${url}`);
        } catch (error) {
          toast.error(error?.response?.data?.error?.code);
        }
      }
    },
    [
      donor,
      likeBtnClicked,
      like,
      url,
      handleLike,
      handleUnlike,
      handleShowAuthModal,
    ]
  );
  return { onLikeBtnClick, like, likeBtnClicked };
};

export default useLike;
